module.exports = __webpack_public_path__ + "assets/img/healthcareSolutions-pathology.c7f5243f.png";